import React from "react";
import { CalendarDays, ChevronRight, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { getLocalDateString, parseLocalDate } from "@/lib/date";

function getTodayLabel() {
  const today = getLocalDateString();
  const d = parseLocalDate(today);
  if (!d) return "";
  return d.toLocaleDateString("es-MX", { weekday: "long", day: "numeric", month: "long" });
}

export default function AgendaHero({ districtName, todayActivity, isCoordinator }) {
  const todayLabel = getTodayLabel();
  const capitalDay = todayLabel.charAt(0).toUpperCase() + todayLabel.slice(1);

  return (
    <div className="px-4 pt-5">
      <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#012e68] via-[#1b4f9c] to-[#2d6cdf] shadow-[0_8px_32px_rgba(27,79,156,0.22)] dark:shadow-none" style={{ WebkitMaskImage: "-webkit-radial-gradient(white, black)" }}>
        {/* Ambient lights */}
        <div className="absolute inset-0 rounded-[inherit] overflow-hidden pointer-events-none">
          <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-white/10 blur-2xl" />
          <div className="absolute bottom-0 -left-4 h-20 w-20 rounded-full bg-cyan-300/10 blur-2xl" />
        </div>

        {/* Main content */}
        <div className="relative px-5 pt-5 pb-4">
          <div className="flex items-start justify-between gap-4">
            {/* Left */}
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="h-12 w-12 rounded-[16px] bg-white/15 border border-white/20 backdrop-blur-sm flex items-center justify-center shrink-0">
                <CalendarDays size={22} className="text-white" strokeWidth={2} />
              </div>
              <div className="min-w-0">
                <p className="text-[11px] uppercase tracking-widest text-white/70 font-medium">
                  {districtName || "Centro temporal"}
                </p>
                <h2 className="text-[22px] font-bold text-white leading-tight">
                  Agenda
                </h2>
                <p className="text-[12px] text-blue-200/80 mt-0.5">
                  {capitalDay}
                </p>
              </div>
            </div>

            {/* CTA: ver agenda global */}
            <Link
              to="/agenda/global"
              className="shrink-0 flex items-center gap-1.5 bg-white/15 hover:bg-white/25 border border-white/20 rounded-full px-4 h-11 text-[11px] font-semibold text-white transition-all duration-200 ease-out active:scale-[0.97]"
            >
              Ver todo
              <ChevronRight size={12} strokeWidth={2.5} />
            </Link>
          </div>
        </div>

        {/* Today activity strip */}
        {todayActivity && (
          <div className="relative mx-4 mb-4 bg-white/10 border border-white/15 rounded-[16px] px-3 py-2.5">
            {isCoordinator && (
              <p className="text-[9px] font-bold uppercase tracking-wider text-white/45 mb-1">
                Actividad del pastor
              </p>
            )}
            <div className="flex items-center gap-2.5">
              <Zap size={13} className="text-white/70 shrink-0" strokeWidth={2} />
              <p className="text-[12px] text-white/85 font-medium leading-snug truncate">
                {todayActivity}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
